import { render } from "./upload-file.vue?vue&type=template&id=2299911c"
import script from "./upload-file.vue?vue&type=script&lang=js"
export * from "./upload-file.vue?vue&type=script&lang=js"
script.render = render

export default script